module.exports = {
    "baseUrl": "https://api-v4.staging.iris-health.com",
    "systemName": "System dev",
    "favicon": "%PUBLIC_URL%/iris-health-logo.jpeg",
    "companyTitle": "Payment Portal | Iris Health",
    "companyKey": "iris",
    "website": "https://iris-health.com/",
    "cdnUrl": "https://cdn.staging.iris-health.com",
    "companyName": "Iris Health",
    "copyRight": "Iris Health is a trademark of its respective owner.",
    "phoneNumber": "(469) 680-1248",
    "isChatBotEnabled": false
}